export default "__VITE_ASSET__5fURK9WL__"